export default "__VITE_ASSET__CcSbmdiF__"